<template>
    <div class="f-nav-flex">
        <ul class="list-wrap">
            <li v-for="item in listItem"
                class="list"
                :class="{ 'active': item.active }"
                v-bind:data-type="item.type"
                v-bind:data-id="item.id"
                v-bind:key="item.id"
                v-on:click="onClickHandle">
                <span>{{ item.text }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    import utils from '../utils'

    export default {
        name: 'f-nav-flex',
        props: {
            listItem: {
                type: Array,
                required: true
            }
        },
        computed: {
            activeItem: {
                get () {
                    for (let i = 0, len = this.listItem.length; i < len; i++) {
                        if (this.listItem[i].active) {
                            return this.listItem[i]
                        }
                    }
                },
                set (id) {
                    for (let i = 0, len = this.listItem.length; i < len; i++) {
                        let item = this.listItem[i]
                        item.active = false

                        if (item.id === id) {
                            item.active = true
                        }
                    }
                }
            }
        },
        methods: {
            onClickHandle (e) {
                var target = utils.closest(e.target, 'list')
                var id = target.getAttribute('data-id')

                this.activeItem = id
                var activeItem = this.activeItem
                this.$emit('nav-item-click', e, JSON.parse(JSON.stringify(activeItem)))
            },
            getActiveItem () {
                return JSON.parse(JSON.stringify(this.activeItem))
            }
        }
    }
</script>

<style lang="stylus">
    .f-nav-flex
        font-size: 14px
        color: #333
        margin: 0
        padding: 0
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
        background: #fff
        .list-wrap
            display: -webkit-box
            display: -webkit-flex
            display: flex
            -webkit-box-pack: justify
            -webkit-justify-content: space-between
            justify-content: space-between
            -webkit-box-align: stretch
            -webkit-align-items: stretch
            align-items: stretch
            height: 40px
            list-style: none
            margin: 0
            padding: 0
            
            .list
                position: relative
                -webkit-box-flex: 1
                -webkit-flex: 1
                box-flex: 1
                flex: 1
                display: -webkit-box
                display: -webkit-flex
                display: flex
                -webkit-box-pack: center
                -webkit-justify-content: center
                justify-content: center
                -webkit-box-align: stretch
                -webkit-align-items: stretch
                align-items: stretch
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
                span
                    line-height: 40px
                    padding: 0 3px
                    display: block
            .active
                &:after
                    content: ''
                    position: absolute
                    left: 50%
                    margin-left: -13px
                    bottom: 0
                    width: 27px
                    height: 3px
                    background: #ff3444
                span
                    color: #ff3444
</style>


// WEBPACK FOOTER //
// nav-flex.vue?1a47eece